import {
  DefenseBrandMotorVehiclesTypes,
  DefenseEventTypes,
  DefenseModelMotorVehiclesTypes,
  DefensePlateColorsTypes,
  DefenseVehicleColorsTypes,
  IDefenseEventNotifyMotorVehicleProps,
} from '../../../../services/Defense/Events/types';
import { Grid2 } from '@mui/material';
import TextFieldComponent from '../../../../components/TextFieldComponent';
import React from 'react';
import {
  convertBrandMotorVehicle,
  convertEventType,
  convertMotorVehicleType,
  convertPlateColor,
  convertVehicleColor,
} from '../../../../converters/Defense/ConverterDefense';
import dayjs from 'dayjs';
import DateFieldComponent from '../../../../components/DateFieldComponent';

interface IDefenseNotifyMotorVehicleContentProps {
  event: IDefenseEventNotifyMotorVehicleProps;
}

const DefenseNotifyMotorVehicleContent = ({
  event,
}: IDefenseNotifyMotorVehicleContentProps) => {
  const formatCreatedAt = (date: Date) => {
    return dayjs(date, 'YYYY/MM/DD HH:mm:ss');
  };

  const formatDefenseDate = (date: Date) => {
    return dayjs(date);
  };

  return (
    <Grid2
      container
      direction={{ xs: 'column', lg: 'row' }}
      size={12}
      spacing={{ xs: 0, lg: 3 }}
      justifyContent={'center'}
      alignItems={{ xs: 'center', lg: 'normal' }}
    >
      <Grid2 size={{ xs: 12, lg: 6 }}>
        <TextFieldComponent
          label="Dispositivo"
          value={event?.device?.name ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Tipo"
          value={
            convertEventType(event.type as DefenseEventTypes) ?? 'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <DateFieldComponent
          label="Data/Hora"
          value={formatCreatedAt(event.createdAt)}
          readOnly={true}
        />
        <TextFieldComponent
          label="ID do Canal"
          value={event?.channelId ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Placa do Veículo"
          value={event?.plate ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Cor da Placa"
          value={
            convertPlateColor(event?.plateColor as DefensePlateColorsTypes) ??
            'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
      </Grid2>

      <Grid2 size={{ xs: 12, lg: 6 }}>
        <TextFieldComponent
          label="Tipo do Veículo"
          value={
            convertMotorVehicleType(
              event?.carType as DefenseModelMotorVehiclesTypes,
            ) ?? 'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Cor do Veículo"
          value={
            convertVehicleColor(event?.carColor as DefenseVehicleColorsTypes) ??
            'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Marca do Veículo"
          value={
            convertBrandMotorVehicle(
              event.carBrand as DefenseBrandMotorVehiclesTypes,
            ) ?? 'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Data/Hora da Captura"
          value={event?.captureTime ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Descrição"
          value={event.description ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
          multiline
        />
      </Grid2>
    </Grid2>
  );
};

export default DefenseNotifyMotorVehicleContent;
